import React, { useState } from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { AlumniOf, SocialMediaType } from 'types/common';
import { classnames } from 'helpers/utils';
import { Button } from 'components/button';
import { SocialMedia } from 'components/social-media/social-media';
import { ContributorTypeEnum, SocialMediaEnum } from 'utils/enums';
import * as styles from './author-reviewer.module.scss';

type AuthorHeaderProps = {
  avatar: IGatsbyImageData,
  fullName: string,
  occupation: string,
  education: AlumniOf[]
  expertise: string,
  socialMedia: SocialMediaType,
  contributorType: ContributorTypeEnum
  slug?: string
};

const contributorTypeIcon = (contributor: ContributorTypeEnum): string => (
  contributor === ContributorTypeEnum.Author ? '✍️' : '🩺'
);

const AuthorReviewerHeader = ({
  avatar, fullName, occupation, education, expertise, socialMedia, contributorType, slug,
}: AuthorHeaderProps) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  return (
    <div className={styles.authorHeader}>
      {slug ? (
        <Link to={slug}>
          <GatsbyImage className={styles.avatar} alt={fullName} image={avatar} />
        </Link>
      )
        : (
          <div>
            <GatsbyImage className={styles.avatar} alt={fullName} image={avatar} />
          </div>
        )}
      <div className={styles.infoBlock}>
        {slug
          ? <Link to={slug}><div className={styles.name}>{fullName}</div></Link>
          : <div className={styles.name}>{fullName}</div>}
        <div className={styles.expertiseOccupation}>
          <div className={styles.icon}>{contributorTypeIcon(contributorType)}</div>
          <div>{contributorType}</div>
          <div className={styles.icon}>🦷</div>
          <div>{occupation}</div>
        </div>
        <div className={classnames(styles.paragraph, styles.line)}>
          <span>Expertise</span>
          <div>{expertise}</div>
        </div>

        <div className={styles.paragraph}>
          <span>Education</span>
          <div>
            {education.map((college, index) => (
              <div key={college.url}>
                {index < 3 && <div>{college.name}</div>}
                {(showMore && index > 2) && <div>{college.name}</div>}
              </div>
            ))}
            {education.length > 3 && (
              <Button
                onClick={() => setShowMore(!showMore)}
                bColor="primary"
                bStyle="link"
                type="button"
              >
                <div>
                  {!showMore ? 'see more' : 'see less'}
                </div>
              </Button>
            )}
          </div>
        </div>

        {socialMedia && (
          <div className={styles.socialMedia}>
            {socialMedia.facebook
              && (
                <SocialMedia
                  type={SocialMediaEnum.Facebook}
                  link={socialMedia.facebook}
                />
              )}
            {socialMedia.instagram
              && (
                <SocialMedia
                  type={SocialMediaEnum.Instagram}
                  link={socialMedia.instagram}
                />
              )}
            {socialMedia.youtube
              && (
                <SocialMedia
                  type={SocialMediaEnum.YouTube}
                  link={socialMedia.youtube}
                />
              )}
            {socialMedia.tiktok
              && (
                <SocialMedia
                  type={SocialMediaEnum.TikTok}
                  link={socialMedia.tiktok}
                />
              )}
          </div>
        )}

      </div>
    </div>
  );
};

export { AuthorReviewerHeader };
